import { render, staticRenderFns } from "./Avatar.ts.vue?vue&type=template&id=9e7e460e"
import script from "./Avatar.ts.vue?vue&type=script&setup=true&lang=ts"
export * from "./Avatar.ts.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Avatar.ts.vue?vue&type=style&index=0&id=9e7e460e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports